import React from 'react';

// Comps
import {Link} from '@arctheme-components/elements/Link/Link';
import Paragraph from '@arctheme-components/elements/Paragraph/Paragraph';

const AccountOrders = ({
  orders,
  locales,
  onClickOrder
}: {
  orders: any;
  locales: any;
  onClickOrder: (event: React.ClickEvent<HTMLLinkElement>, order: any) => void;
}) => {
  return (
    <div className='account-orders flex w-full'>
      {orders.length ? (
        <table className={`w-full`}>
          <thead>
            <tr className={`h6 text-left`}>
              <th>{locales.order}</th>
              <th>{locales.date}</th>
              <th>{locales.paymentStatus}</th>
              <th>{locales.fulfillmentStatus}</th>
              <th>{locales.total}</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.orderName} className={'b2 text-left text-black'}>
                <td
                  data-label={locales.order}
                >
                  {order.orderName}
                </td>
                <td
                  data-label={locales.date}
                >
                  {order.createdAt}
                </td>
                <td
                  data-label={locales.paymentStatus}
                >
                  {order.paymentStatus}
                </td>
                <td
                  data-label={locales.fulfillmentStatus}
                >
                  {order.fulfillmentStatus}
                </td>
                <td
                  data-label={locales.total}
                >
                  {order.total}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Paragraph
          type='b2 text-center'
          text={locales.empty}
        />
      )}
    </div>
  );
};

export default AccountOrders;
